import { render, staticRenderFns } from "./RatingInfo.vue?vue&type=template&id=fd607412&"
import script from "./RatingInfo.vue?vue&type=script&lang=js&"
export * from "./RatingInfo.vue?vue&type=script&lang=js&"
import style0 from "./RatingInfo.vue?vue&type=style&index=0&id=fd607412&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports